import "./home.css";
import { Link } from "react-router-dom";
import "react-dropdown/style.css";

//Components
import Header from "../../components/header";
import Footer from "../../components/footer";


// React-resposive-carousel
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

//import Lazy Load
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

//Search
import SelectSearch from 'react-select-search';
import 'react-select-search/style.css'

import showcase1 from "../../media/images/showcaseNew/canvaEdit/5.webp";
import showcase2 from "../../media/images/showcaseNew/canvaEdit/4.webp";
import showcase3 from "../../media/images/showcaseNew/canvaEdit/3.webp";
import showcase4 from "../../media/images/showcaseNew/canvaEdit/2.webp";
import showcase5 from "../../media/images/showcaseNew/canvaEdit/1.webp";

import truckSmaller from "../../media/images/showcaseNew/canvaEdit/2Small.webp"
import childSmaller from "../../media/images/showcaseNew/canvaEdit/4Small.webp"
import groupSmaller from "../../media/images/showcaseNew/canvaEdit/3Small.webp" 
import workSmaller from "../../media/images/showcaseNew/canvaEdit/5Small.webp" 
import momSmaller from "../../media/images/showcaseNew/canvaEdit/1Small.webp" 

//thumbnails

import product1 from "../../media/images/product1.webp";
import product2 from "../../media/images/product2.webp";
import product3 from "../../media/images/product3.webp";

import product1Small from "../../media/images/product1Small.webp";
import product2Small from "../../media/images/product2Small.webp";
import product3Small from "../../media/images/product3Small.webp";
//accordion

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import 'react-accessible-accordion/dist/fancy-example.css';


const Home = () => {

  const options = [

    {
        type: 'group',
        name: 'Middlesex county',
        items: [
            {name: 'Carteret', value: 'Carteret'},
            {name: 'Cranbury', value: 'Cranbury'},
            {name: 'East Brunswick', value: 'East Brunswick'},
            {name: 'Edison', value: 'Edison'},
            {name: 'Highland Park', value: 'Highland Park'},
            {name: 'Metuchen', value: 'Metuchen'},
            {name: 'New Brunswick', value: 'New Brunswick'},
            {name: 'Parlin', value: 'Parlin'},
        ]
    },
    {
      type: 'group',
      name: 'Monmouth County',
      items: [
          {name: 'Coming Soon', value: 'Monmouth'},
      ]
  },
];



  return (
    <>
      
      <Header />

      <Carousel id="showcaseCarousel" autoPlay infiniteLoop>
     
        <div>
          <img 
          srcSet={`${truckSmaller} 800px`}
          src={showcase4} 
          fetchpriority="high"
          loading="lazy"
          alt='Ice Cream Creations Truck' id='mainImage' />
          
          <div className='container'>
            <Link className='btnLink' to={"../booking"}>
              Book now
            </Link>
            <div className="photoCover"/> 
          </div>
        </div>

        <div>
          <img
            srcSet={`${childSmaller} 800px`} 
            src={showcase2}
            loading="lazy"
            fetchpriority="low"
            alt='Happy child eating ice cream with gummy bears'
            id='mainImage'
          />

          <div className='container'>
            <Link className='btnLink' to={"../booking"}>
              Book now
            </Link>
            <div className="photoCover"/> 
          </div>
        </div>

        <div>
          <img 
          srcSet={`${groupSmaller} 800px`}
          src={showcase3} 
          fetchpriority="low"
          loading="lazy"
          alt='Group in front of the ice cream truck' 
          id='mainImage' />

          <div className='container'>
            <Link className='btnLink' to={"../booking"}>
              Book now
            </Link>
            <div className="photoCover"/> 
          </div>
        </div>

        <div>
          <img 
          srcSet={`${workSmaller} 800px`}

          src={showcase5} 
          fetchpriority="low"
          loading="lazy"
          alt='Group eating ice cream on a sunny day' 
          id='mainImage' />

          <div className='container'>
            <Link className='btnLink' to={"../booking"}>
              Book now
            </Link>
            <div className="photoCover"/> 
          </div>
        </div>
        <div>
          <img 
          srcSet={`${momSmaller} 800px`}
          src={showcase1} 
          fetchpriority="low"
          loading="lazy"
          alt='Mom and daughter enjoying Ice Cream Creations' 
          id='mainImage' />

          <div className='container'>
            <Link className='btnLink' to={"../booking"}>
              Book now
            </Link>
            <div className="photoCover"/> 
          </div>
        </div>
      </Carousel>

      <main>
        <div className="fadeInText">
        <h1>An Ice Cream Truck For Any Occasion</h1>
        </div>


        <p id='caption'>Birthday Parties, Weddings, Bar & Bat Mitzvahs, and more!</p>

        <section id="intro">
        <div className="blueBox">
          <h2>Bring us to your event!</h2>
          </div>
          <div className="blueBox">
          <p>
            An ice cream truck is the perfect treat for any occasion. We bring a large variety of
            flavor and toppings, and can accomidate any dietary requriements.
          </p>
        </div>
          
          <section id='products'>

            <div className='galleryGrid'>


            <div className='item'>
              <LazyLoadImage 
              threshold={1000}
              alt={"Sundae with Sprinkles and Chocolate sauce"}
              height={300}
              srcSet={`${product1Small} 800px`} 
              src={product1} 
              width={300}
              effect="blur"
               />
              <h2>Sundaes</h2>
            </div>


            <div className='item'>
              <LazyLoadImage
              alt={"Pineapple Cream Float"}
              height={300}
              srcSet={`${product2Small} 800px`} 
              src={product2} 
              width={300}
              effect="blur" />
              <h2>Floats</h2>


            </div>


            <div className='item'>
              <LazyLoadImage 
              alt={"Ice cream with whipped cream"}
              height={300}
              srcSet={`${product3Small} 800px`} 
              src={product3} 
              width={300}
              effect="blur" />
              <h2>And more!</h2>
            </div>

            
            </div>
          </section>
      
        </section>
      

        <section id='locations'>
         

          <div id='locationContainer'>
           

            <div id='locationTextbox'> 
            <h2>See if we are in your area!</h2>
            <SelectSearch options={options} search placeholder="Select your city" />
            
            </div>
          </div>

        </section>

        <section id='reviews'>

          <div class="elfsight-app-e1e7cb2d-2eba-4481-a8e1-57f11b623cfb"></div>
          
        </section>

      <div id="safetySpacing">
        <div className="blueBox">
              <h2>Safety</h2>
          </div> 
          <div className="blueBox">
            <h3>How Ice Cream Creations is keeping customers safe. </h3>
        </div>
        <div className="row">

        <section id='safety' className='newCol'>
      

          <h3>Allergies and Dietary Restrictions</h3>
          <Accordion className="faqContainer">
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                   Kosher
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    All Ice Cream Creations products carry a Kosher certification.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Vegan & Dairy Free
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Ice Cream Creations has a wide offering of ice creams that are free of dairy or animal products.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Allergens
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Any products containing nuts are kept away from the main prep space.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>




          <h3>Cleanliness</h3>
          <Accordion className="faqContainer">
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Hygiene
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Our employees are held to strict hygiene standards. For each item preparation, a new pair of gloves is required. Handwashing twice per hour is required. Employees will be masked at request of customer.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Contactless payment
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Contactless payment is preferred to cash for sanitary reasons. Customers can utilize contactless / chip card payment, digital wallet payments, Paypal/Venmo, and Cash App payments.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
      
        </Accordion>

        


        </section>
        </div>
          
        </div>
       

        <section id='questions'>
          <h2>Frequently Asked Questions</h2>
          


          <Accordion className="faqContainer">
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Does Ice Cream Creations only serve Middlesex County?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    We are exclusively serving Middlesex County. We are considering expansion in the
                   future.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Does the menu of ice cream offerings rotate?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Absolutely! Our menu is just a sample of our offerings. We frequently feature seasonal
                    specials.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Is Ice Cream Creations exclusively for private events?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    No, we frequently make appearances with the truck at public events. For upcoming
                    events that we will be attending, check out our Calendar page.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>

        </section>
      </main>
      <Footer />

    </>
  );
};

export default Home;
